
import { Component, Vue, Prop } from 'vue-property-decorator'
import { UserModule } from '../../store/modules/user'
import { formatDate } from '../../utils/publish'
import DashboardCustomerDetails from './DashboardCustomerDetails.vue'
  @Component({ 
    name: 'DashboardCustomerList',
    components: { DashboardCustomerDetails } 
  })
  
export default class DashboardRatio extends Vue {
  @Prop() saleListData
  @Prop() total_count

  customerDetails: any = {}
  is_show_customer_info: boolean = false

  mounted() {

  }
  getTime(val, type) {
    return formatDate(val, type)
  }
  closeCustomer() {
    this.is_show_customer_info = false
  }
  getCustomerDetails(val) {
    this.customerDetails = val
    this.is_show_customer_info = true
  }
  handleCurrentChange(val) {
    this.$emit('handle-page-change', {page: val})
  }
}
